/**
 * Ableitung der sichtbaren Abspielposition aus der (Audio-)Zeit.
 *
 * Rein funktional: Grundlage ist ausschließlich die vergangene Audiozeit,
 * nicht die Anzahl vergangener UI-Timer-Aufrufe. Dadurch bleibt die Anzeige
 * an die maßgebliche AudioContext-Zeitbasis gekoppelt.
 */

/**
 * Bestimmt den aktuell klingenden Rasterschritt.
 *
 * @param elapsedSeconds vergangene Zeit seit Patternstart (Audiozeit)
 * @param stepDuration   Dauer eines Rasterschritts in Sekunden
 * @param stepCount      Anzahl der Rasterschritte im Pattern
 * @param loop           ob das Pattern in Schleife läuft
 * @returns Schrittindex (0..stepCount-1) oder `null`, wenn keine Position
 *          aktiv ist (vor dem Start bzw. nach dem Ende ohne Loop).
 */
export function playheadStep(
  elapsedSeconds: number,
  stepDuration: number,
  stepCount: number,
  loop: boolean,
): number | null {
  if (!Number.isFinite(elapsedSeconds) || elapsedSeconds < 0) {
    return null;
  }
  if (!Number.isFinite(stepDuration) || stepDuration <= 0 || stepCount <= 0) {
    return null;
  }

  const rawIndex = Math.floor(elapsedSeconds / stepDuration);

  if (loop) {
    return ((rawIndex % stepCount) + stepCount) % stepCount;
  }
  if (rawIndex >= stepCount) {
    return null;
  }
  return rawIndex;
}
